import React from 'react'

const SuppliersProgress = ({ suppliers = [], className = '' }) => {
  const totalSuppliers = suppliers.length
  const respondedSuppliers = suppliers.filter(
    supplier => supplier.quotation_supplier_status_id === 4
  ).length
  
  const progress = totalSuppliers > 0 ? (respondedSuppliers / totalSuppliers) * 100 : 0

  const getProgressColor = () => {
    if (progress === 100) return 'bg-green-500'
    if (progress >= 50) return 'bg-blue-500'
    if (progress >= 25) return 'bg-yellow-500'
    return 'bg-gray-400'
  }

  return (
    <div className={`bg-white dark:bg-dark-bg-secondary rounded-lg border border-gray-200 dark:border-dark-border-primary p-4 transition-colors ${className}`}>
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold text-gray-800 dark:text-dark-text-primary">Respostas dos Fornecedores</h3>
        <span className="text-sm font-medium text-gray-600 dark:text-dark-text-secondary">
          {respondedSuppliers}/{totalSuppliers}
        </span>
      </div>
      
      <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2 mb-3">
        <div 
          className={`h-2 rounded-full transition-all duration-300 ${getProgressColor()}`}
          style={{ width: `${progress}%` }}
        />
      </div>

      {progress === 100 && (
        <div className="flex items-center gap-2 text-green-600 dark:text-green-400 text-sm font-medium">
          <span>✅</span>
          <span>Todos os fornecedores responderam!</span>
        </div>
      )}

      {totalSuppliers > 0 && progress < 100 && (
        <div className="space-y-1">
          {suppliers.map((supplier) => {
            const supplierName = supplier.supplier?.trade_name || supplier.supplier?.legal_name || supplier.supplier_name || 'Fornecedor'
            return (
              <div key={supplier.id} className="flex items-center justify-between text-xs">
                <span className="text-gray-600 dark:text-dark-text-secondary truncate">{supplierName}</span>
                <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                  supplier.quotation_supplier_status_id === 4 
                    ? 'bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-400' 
                    : 'bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-300'
                }`}>
                  {supplier.quotation_supplier_status_id === 4 ? '✅' : '⏳'}
                </span>
              </div>
            )
          })}
        </div>
      )}

      {totalSuppliers === 0 && (
        <p className="text-sm text-gray-500 dark:text-dark-text-muted text-center py-2">
          Nenhum fornecedor associado ainda
        </p>
      )}
    </div>
  )
}

export default SuppliersProgress
